import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState, useEffect, useRef } from "react";
import {  IconButton, Modal, Box, Dialog, DialogActions, DialogContent, TextField, DialogTitle, Grid, Card, CardContent, FormControlLabel, Checkbox } from '@mui/material';
import Table from 'react-bootstrap/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import { ToastContainer,toast } from "react-toastify";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import { Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { getAllUsers } from "assets/globalAPI/apiGlobal";
import { fetchRoleMaster } from "assets/globalAPI/apiGlobal";
import { createUser } from "assets/globalAPI/apiGlobal";

const UsersList=()=>{
 const toastId= useRef(null)
    const navigate= useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [isActive,setIsActive]= useState(false)
    const [userDetails,setUserDetails]= useState([])
    const [currentPage,setCurrentPage]= useState(1);
    const [rolePage,setRolePage]= useState(1);
    const [totalPages,setTotalPages]= useState(1);
    const [totalRolePages,setTotalRolePages]= useState(1);
    const [selectedUser,setSelectedUser]= useState(null);
    const [roles,setRoles]= useState([]);
    const [memberOf,setMemberOf]= useState("")
    const [memberOfName,setMemberOfName]= useState("")
    const [userId,setUserId]= useState("")
    const [newName,setNewName]= useState("");
    const [newEmail,setNewEmail]= useState("");
    const [newPassword, setNewPassword]= useState("");
    const [newDesignation,setNewDesignation]= useState("");
    const [newDepartment,setNewDepartment]= useState("");
    const [newMemberOf,setNewMemberOf]= useState("");
    const [newMemberOfDisplay,setNewMemberOfDisplay]= useState("");
    const [newRole,setNewRole]=useState("");
    const [newRoleName,setNewRoleName]= useState("");
    const [newAdmin,setNewAdmin]=useState(0);
    const [edit,setEdit]=useState(false)
    const [userSearch,setUserSearch]= useState("");
    const typingTimeoutRef = useRef(null);
          const latestSearchRef = useRef("");

    const fetchAllUsers=async()=>{
      setIsActive(true)
        setIsActive(true)
        const body={
            page: latestSearchRef.current==""? currentPage:1,
            search: latestSearchRef.current
        }
        try{
            const response= await getAllUsers(body);
            const res= response.data;
            console.log("response is>> ", res)
            if(res.status){
                setIsActive(false)
                console.log("all users fetched>> ", res);
                setUserDetails(res.data);
                setTotalPages(res.totalPages)
            }else{
                console.log("could not fetch users>> ", res);
                setTotalPages(1)
                setUserDetails([])
                setIsActive(false)
            }
        }catch(err){
            console.log("the error is bringing users>> ", err)
            setIsActive(false)
            
        }
      }

      const handleSearchChange = (e) => {
        const value = e.target.value;
        setUserSearch(value);
        latestSearchRef.current = value;
     
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
     
       
    typingTimeoutRef.current = setTimeout(() => {
      fetchAllUsers(); // Inside this function, access latest value from latestSearchRef.current
    }, 2000);
    }
      const fetchRoles = async () => {
        setIsActive(true)
        const body={
          page: rolePage
        }
          try {
            const response = await fetchRoleMaster(body); // Replace with your API
            const res= response.data;
            if(res.status){
              setRoles(res.data);
              setTotalRolePages(res.totalPages)
              setIsActive(false)
              console.log("Roles fetched successfully:", res.data);
            }else{
              console.log("Roles not fetched>> ", res)
              setTotalRolePages(1)
              setIsActive(false)
            }
          } catch (error) {
            console.error("Error fetching roles:", error);
            setTotalRolePages(1)
            setIsActive(false)
            if(error.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Your Session has expired",{
                  className:"small-toast"
                })
              }
              setIsActive(false)
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
              return;
            }
          }
        };

        useEffect(()=>{
            fetchRoles()
        },[rolePage])

      useEffect(()=>{
        fetchAllUsers();
      },[currentPage])

      const handleOpenDialog = (user) => {
        console.log("consoling the user>> ", user)
        setSelectedUser(user);
        setUserId(user.userid)
        setNewName(user.name);
        setNewEmail(user.email);
        setNewPassword(user.password);
        setNewDesignation(user.designation);
        setNewDepartment(user.department);
        setNewRole(user.user_role);
        setNewRoleName(user.role_name)
        setNewMemberOf(user.member_of);
        setNewMemberOfDisplay(user.member_of_name);
        setNewAdmin(user.isadmin)
        setOpenDialog(true);
      };

      const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedUser(null);
        setEdit(false)
      };

      const handlePageChange=(p)=>{
        setCurrentPage(p)
        
      }

      const handlePageChange2=(p)=>{
        setRolePage(p)
        
      }

      const handleOpenUserDialog=()=>{
        fetchAllUsers(currentPage)
        
          setOpen(true);
      }

      const handleUserChange = (selectedOption) => {
        setMemberOf(selectedOption.id);
        setMemberOfName(selectedOption.name)
         console.log("upadted used is>> ", selectedOption)
         setOpen(false);
       };


       const submitUser=async(e)=>{
        e.preventDefault();
        setIsActive(true)
        const body={
            "userid":userId,
    "name":newName,
    "email":newEmail,
    "password":newPassword,
    "user_type":"initiator",
    "designation":newDesignation,
    "department":newDepartment,
     "member_of": newMemberOf,
    "user_role": newRole,
    "isadmin":newAdmin
        }
         try{
            const response= await createUser(body);
            const res= response.data;
            console.log("The response after registering>> ", res);
            if(res.status){
              if(! toast.isActive(toastId.current)) {
                toastId.current = toast.success(res.message,{
                  className: "small-toast"
                });  
              }
              console.log("the success>> ", res);
             setIsActive(false)
             setOpenDialog(false);
             fetchAllUsers()
        
            }else{
              if(! toast.isActive(toastId.current)) {
                toastId.current = toast.error(res.message,{
                  className: "small-toast"
                });  
              }
              console.log("failed to create>> ", res)
              setIsActive(false)
            }
           }catch(error){
            if(! toast.isActive(toastId.current)) {
              toastId.current = toast.error("Error creating user",{
                className: "small-toast"
              });  
            }
            setIsActive(false)
            if(error.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Your Session has expired",{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
              return;
            }
            console.log("Error in registering>> ", error)
           }
       }

       


      return(
         <DashboardLayout>
            <DashboardNavbar/>
            <ToastContainer/>
            <SimpleBackdrop openLoader={isActive}/>
            <div style={{display:"flex",}}>   

            <input
      type="text"
      placeholder="Search with name or SAP code"
      className="form-control"
      style={{ maxWidth: "250px" , fontSize: "12px"}}
      onChange={(e)=>handleSearchChange(e)}
    />
            </div>
            <div style={{overflowX: "auto", marginTop: "20px"}}>
            <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
            <thead>
            <tr style={{color : "white",backgroundColor: "#3498db"}}>
            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >USER ID</th>
            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >USER NAME</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >USER EMAIL</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >USER DEPARTMENT</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >USER DESIGNATION</th>
            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0', fontSize: "15px" }}>ACTION</th>
            </tr>
            </thead>
            <tbody>
                {userDetails.map((user)=>(
                    <tr key={user.id}>
                         <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.userid}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.name}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.email}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.department}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.designation}</td>
                  <td >
                                  <SoftButton variant="text" color="primary" onClick={() => handleOpenDialog(user)}>
                                  <Icon>visibility</Icon>
                                </SoftButton>
                                </td>
                    </tr>
                ))}
            </tbody>
            </Table>
            </div>
             {/* <Pagination className="mt-3">
                            <Pagination.Prev 
                              disabled={currentPage === 1} 
                              onClick={() => handlePageChange(currentPage - 1)}
                            />
                            {[...Array(totalPages).keys()].map((page) => (
                              <Pagination.Item 
                                key={page + 1} 
                                active={page + 1 === currentPage} 
                                onClick={() => handlePageChange(page + 1)}
                              >
                                {page + 1}
                              </Pagination.Item>
                            ))}
                            <Pagination.Next 
                              disabled={currentPage === totalPages} 
                              onClick={() => handlePageChange(currentPage + 1)}
                            />
                          </Pagination> */}


                           <Pagination className="mt-3">
                            <Pagination.Prev
                              disabled={currentPage === 1}
                              onClick={() => handlePageChange(currentPage - 1)}
                              style={{
                                color: "danger",
                                borderRadius: "5px",
                              }}
                            />
                          
                            {/* Always show first page */}
                            <Pagination.Item
                              active={currentPage === 1}
                              onClick={() => handlePageChange(1)}
                              style={{
                                color: currentPage === 1 ? "#fff" : "danger",
                                backgroundColor: currentPage === 1 ? "danger" : "transparent",
                                borderRadius: "5px",
                              }}
                            >
                              1
                            </Pagination.Item>
                          
                            {/* Left dots */}
                            {currentPage > 3 && <Pagination.Ellipsis disabled />}
                          
                            {/* Middle page numbers */}
                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                              .filter(
                                (page) =>
                                  page !== 1 &&
                                  page !== totalPages &&
                                  Math.abs(currentPage - page) <= 1
                              )
                              .map((page) => (
                                <Pagination.Item
                                  key={page}
                                  active={page === currentPage}
                                  onClick={() => handlePageChange(page)}
                                  style={{
                                    color: page === currentPage ? "#fff" : "danger",
                                    backgroundColor: page === currentPage ? "danger" : "transparent",
                                    borderRadius: "5px",
                                  }}
                                >
                                  {page}
                                </Pagination.Item>
                              ))}
                          
                            {/* Right dots */}
                            {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}
                          
                            {/* Always show last page */}
                            {totalPages > 1 && (
                              <Pagination.Item
                                active={currentPage === totalPages}
                                onClick={() => handlePageChange(totalPages)}
                                style={{
                                  color: currentPage === totalPages ? "#fff" : "danger",
                                  backgroundColor:
                                    currentPage === totalPages ? "danger" : "transparent",
                                  borderRadius: "5px",
                                }}
                              >
                                {totalPages}
                              </Pagination.Item>
                            )}
                          
                            <Pagination.Next
                              disabled={currentPage === totalPages}
                              onClick={() => handlePageChange(currentPage + 1)}
                              style={{
                                color: "danger",
                                borderRadius: "5px",
                              }}
                            />
                          </Pagination>


                           <Dialog
                                  open={openDialog}
                                  onClose={handleCloseDialog}
                                  fullScreen
                                  maxWidth="md"
                                  fullWidth
                                >
                                    <DialogTitle>
                                              <div style={{display:'flex', justifyContent:'space-between'}}>
                                    
                                    
                                              <span style={{fontSize: "25px"}}>User Details</span>
                                              <SoftBox display="flex" justify-content= "space-between" gap={2}>
                                                <SoftButton  onClick={()=>setEdit(true)}  variant="contained" color="info">
                                                                Edit
                                                              </SoftButton>
                                              </SoftBox>
                                                
                                              </div>
                                              
                                            </DialogTitle>

                                             <DialogContent>
                                                <SoftBox className="bp">
                                                    <form noValidate onSubmit={submitUser}>
                                                        {selectedUser &&
                                                        
                                                        <SoftBox py={3} className="customerblock">
                                                            <Grid container spacing={3}>
                                                                 <Grid item xs={12} lg={12}>
                                                                    <Card sx={{ overflow: "visible" }}>
                                                                          <SoftBox p={3}>
                                                                            <SoftBox mt={1}>
                                                                                <Grid container spacing={3}>
                                                                                  
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 User Name
                                                                                                 </SoftTypography>
                                                                                                  <SoftInput
                                                                                                 disabled={edit? false:true}
                                                                                                  onChange={(e)=>setNewName(e.target.value)}
                                                                                                  value={newName}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>

                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 User Email
                                                                                                 </SoftTypography>
                                                                                                  <SoftInput
                                                                                                   disabled={edit? false:true}
                                                                                                  onChange={(e)=>setNewEmail(e.target.value)}
                                                                                                  value={newEmail}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 User Password
                                                                                                 </SoftTypography>
                                                                                                  <SoftInput
                                                                                                  disabled={edit? false:true}
                                                                                                  onChange={(e)=>setNewPassword(e.target.value)}
                                                                                                  value={newPassword}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 User Designation
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                   isDisabled={edit? false:true}
                                                                                                  onChange={(e)=>setNewDesignation(e.value)}
                                                                                                  value={[
                                                                                                    {value: newDesignation, label:  newDesignation}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                      { value: "ASM", label: "ASM" },
                    { value: "Infra Officer", label: "Infra Officer" },
                    { value: "RSM", label: "RSM" },
                    { value: "Trade Marketing Manager", label: "Trade Marketing Manager" },
                    { value: "ZSM", label: "ZSM" },
                    { value: "NSM", label: "NSM" },
                    { value: "MDM", label: "MDM" },
                    { value: "Sales", label: "Sales" },
                    { value: "Accounts", label: "Accounts" },
                    { value: "BIZOM", label: "BIZOM" },
                    { value: "Supply Chain Management", label: "Supply Chain Management" },
                    { value: "MIS", label: "MIS" },
                    { value: "Others", label: "Others" },
                                                                                                  ]} 
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 User Department
                                                                                                 </SoftTypography>
                                                                                                  <SoftInput
                                                                                                   disabled={edit? false:true}
                                                                                                  onChange={(e)=>setNewDepartment(e.target.value)}
                                                                                                  value={newDepartment}
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 User Role
                                                                                                 </SoftTypography>
                                                                                                  <SoftInput
                                                                                                  disabled={edit? false:true}
                                                                                                  onClick={(e)=>{
                                                                                                    setOpen2(true)
                                                                                                    }}
                                                                                                  value={newRoleName}
                                                                                                  // options={roles} 
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Member Of
                                                                                                 </SoftTypography>
                                                                                                 <TextField  disabled={edit? false:true} value={memberOfName || newMemberOfDisplay} placeholder="Member Of.." sx={{cursor: 'pointer'}} onClick={() =>{ 
                                                                                                                 if(edit){
                                                                                                                     handleOpenUserDialog()

                                                                                                                 } else{
                                                                                                                    return;
                                                                                                                 }         
                                                                                                                             }} variant="outlined"
                                                                                                                             inputProps={{
  style: {fontWeight: 400} 
}}// font size of input text
                                                                                                                              InputLabelProps={{style: {fontWeight: 400}}}
                                                                                                                             fullWidth />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} sm={4}>
                                                                                            <SoftBox mb={3}>
                                                                                                 <SoftTypography
                                                                                                component="label"
                                                                                                variant="caption"
                                                                                                 fontWeight="bold"
                                                                                                 textTransform="capitalize"
                                                                                                 >
                                                                                                 Is Admin?
                                                                                                 </SoftTypography>
                                                                                                  <SoftSelect
                                                                                                   isDisabled={edit? false:true}
                                                                                                  onChange={(e)=>setNewAdmin(e.value)}
                                                                                                  value={[
                                                                                                    {value: newAdmin, label:newAdmin==0?"No": "Yes"}
                                                                                                  ]}
                                                                                                  options={[
                                                                                                    { value: 1, label: "Yes" },
                                                                                                    { value: 0, label: "No" },
                                                                                                  ]} 
                                                                                                />
                                                                                            </SoftBox>
                                                                                        </Grid>
                                                                                </Grid>

                                                                                <Grid container spacing={3}>
                                                                                 <Grid item xs={12} lg={12}>
                                                                                   <Card sx={{ overflow: "visible" }}>
                                                                                     <SoftBox p={3}>
                                                                                       <Grid container justifyContent="flex-end" mt={2} spacing={2}>
                                                                                       <Grid item>
                                                                                           <SoftButton onClick={handleCloseDialog} variant="contained" color="error">
                                                                                             Close
                                                                                           </SoftButton>
                                                                                         </Grid>
                                                                                         <Grid item>
                                                                                           <SoftButton  disabled={edit? false:true} type="submit"  variant="contained" color="success">
                                                                                             Submit
                                                                                           </SoftButton>
                                                                                         </Grid>
                                                                                       </Grid>
                                                                                     </SoftBox>
                                                                                   </Card>
                                                                                 </Grid>
                                                                                </Grid>
                                                                            </SoftBox>
                                                                          </SoftBox>
                                                                    </Card>
                                                                 </Grid>
                                                            </Grid>
                                                        </SoftBox>
                                                        }

                                                        
                                                                                         {/* <SoftBox py={3} className="customerblock">
                                                                                <Grid container spacing={3}>
                                                                                 <Grid item xs={12} lg={12}>
                                                                                   <Card sx={{ overflow: "visible" }}>
                                                                                     <SoftBox p={3}>
                                                                                       <Grid container justifyContent="flex-end" mt={2}>
                                                                                         <Grid item>
                                                                                           <SoftButton onClick={handleCloseDialog} variant="contained" color="error">
                                                                                             Close
                                                                                           </SoftButton>
                                                                                         </Grid>
                                                                                       </Grid>
                                                                                     </SoftBox>
                                                                                   </Card>
                                                                                 </Grid>
                                                                                </Grid>
                                                                                </SoftBox> */}
                                                    </form>

                                                    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                                                    <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>Select a User</DialogTitle>
        <DialogContent>
        <input
                                    type="text"
                                    placeholder="Search using Name or Code"
                                    value={userSearch}
                                    onChange={(e) => handleSearchChange(e)}
                                    style={{
                                      width: "100%",
                                      padding: "5px",
                                      marginBottom: "10px",
                                      fontSize: "12px",
                                    }}
                                  />
          <>
          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
          <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>EMAIL</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>USER ID</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>
        </tr>
      </thead>
              {/* <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>User ID</TableCell>
                  <TableCell>Plant</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead> */}
               <tbody>
                                                         
                                                             <>
                                                             {userDetails && userDetails.map((user) => (
                                                               <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                                 <td>{user.name}</td>
                                                                 <td>{user.email}</td>
                                                                 <td>{user.userid}</td>
                                                                 <td>
                                                                   <SoftButton variant="contained" size="small" color="error" onClick={() => handleUserChange(user)}>Select</SoftButton>
                                                                 </td>
                                                               </tr>
                                                             ))}
                                                             </>
                                                             {userDetails?.length === 0 ? (
  <SoftTypography variant="caption">No Users Found</SoftTypography>
) : null}
                                                         </tbody>
            </Table>
          </>
          <Pagination className="mt-3">
                  <Pagination.Prev 
                    disabled={currentPage === 1} 
                    onClick={() => handlePageChange(currentPage - 1)}
                  />
                  {[...Array(totalPages).keys()].map((page) => (
                    <Pagination.Item 
                      key={page + 1} 
                      active={page + 1 === currentPage} 
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next 
                    disabled={currentPage === totalPages} 
                    onClick={() => handlePageChange(currentPage + 1)}
                  />
                </Pagination>
        </DialogContent>
      </Dialog>
                                                </SoftBox>
                                             </DialogContent>
                                </Dialog>

                                <Dialog open={open2} onClose={() => setOpen2(false)} maxWidth="md" fullWidth>
                                        <SimpleBackdrop openLoader={isActive}/>
                                        <DialogTitle>Select a Role</DialogTitle>
                                        <DialogContent>
                                          {/* <input
                                                                    type="text"
                                                                    placeholder="Search using Name or Code"
                                                                    value={userSearch}
                                                                    onChange={(e) => handleSearchChange(e)}
                                                                    style={{
                                                                      width: "100%",
                                                                      padding: "5px",
                                                                      marginBottom: "10px",
                                                                      fontSize: "12px",
                                                                    }}
                                                                  /> */}
                                          <>
                                          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                                          <thead>
                                        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>CUSTOMER VIEW</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>CUSTOMER APPROVAL</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>CUSTOMER EDIT</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>VENDOR VIEW</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>VENDOR APPROVAL</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>VENDOR EDIT</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL VIEW</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL CREATE</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL APPROVAL</th>
                                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>
                                
                                        </tr>
                                      </thead>
                                               <tbody>
                                                                                         
                                                                                             <>
                                                                                             {roles && roles.map((user) => (
                                                                                               <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                                                                 <td>{user.role_name}</td>
                                                                                                 <td>{user.customer_view}</td>
                                                                                                 <td>{user.customer_approval}</td>
                                                                                                 <td>{user.customer_edit}</td>
                                                                                                 <td>{user.vendor_view}</td>
                                                                                                 <td>{user.vendor_approval}</td>
                                                                                                 <td>{user.vendor_edit}</td>
                                                                                                 <td>{user.material_view}</td>
                                                                                                 <td>{user.material_create}</td>
                                                                                                 <td>{user.material_approval}</td>
                                                                                                 <td>
                                                                                                   <SoftButton variant="contained" size="small" color="error" onClick={() => {
                                                                                                    setOpen2(false)
                                                                                                    setNewRole(user.role_id)
                                                                                                    setNewRoleName(user.role_name)}}>Select</SoftButton>
                                                                                                 </td>
                                                                                               </tr>
                                                                                             ))}
                                                                                             </>
                                                                                             {roles?.length === 0 ? (
                                  <SoftTypography variant="caption">No Roles Found</SoftTypography>
                                ) : null}
                                                                                         </tbody>
                                            </Table>
                                          </>
                                         <Pagination className="mt-3">
                                                                     <Pagination.Prev 
                                                                       disabled={rolePage === 1} 
                                                                       onClick={() => handlePageChange2(rolePage - 1)}
                                                                     />
                                                                     {[...Array(totalRolePages).keys()].map((page) => (
                                                                       <Pagination.Item 
                                                                         key={page + 1} 
                                                                         active={page + 1 === rolePage} 
                                                                         onClick={() => handlePageChange2(page + 1)}
                                                                       >
                                                                         {page + 1}
                                                                       </Pagination.Item>
                                                                     ))}
                                                                     <Pagination.Next 
                                                                       disabled={rolePage === totalRolePages} 
                                                                       onClick={() => handlePageChange2(rolePage + 1)}
                                                                     />
                                                                   </Pagination>
                                        </DialogContent>
                                      </Dialog>
         </DashboardLayout>
      )
}

export default UsersList;